/* eslint-disable react/jsx-props-no-spreading */
import { ComponentType } from 'react';
import { Redirect, Route, RouteProps, useLocation } from 'react-router-dom';

import { FeedbackButton } from '../components/PanelLayout/Buttons/FeedbackButton';
import { LOCAL_STORAGE } from '../constants/local-storage.constant';
import { useAuth } from '../hooks/useAuth';

interface PrivateRouteProps extends RouteProps {
  component: ComponentType;
}

export const PrivateRoute = ({
  component: Component,
  ...rest
}: PrivateRouteProps) => {
  const { isLoading } = useAuth();
  const apiToken = localStorage.getItem(LOCAL_STORAGE.CUSTOMER_API_TOKEN);
  const location = useLocation();

  if (!isLoading && !apiToken) {
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: {
            prevPath: `${location.pathname}${location.search}`,
          },
        }}
      />
    );
  }

  return (
    <Route {...rest}>
      <>
        <Component />
        <FeedbackButton />
      </>
    </Route>
  );
};
